// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-password-content {
  min-height: 100vh;
  --background: linear-gradient(135deg, var(--ion-color-primary) 0%, var(--ion-color-primary-darker) 100%);
}

.cp-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
@media (min-width: 768px) {
  .cp-wrapper {
    padding: 24px;
  }
}

.change-password-card {
  position: relative;
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  width: 100%;
  padding: 32px 20px;
  animation: cpFadeInUp 0.5s ease-out;
  min-height: 100vh;
  border-radius: 0;
  box-shadow: none;
  max-width: none;
}
@media (min-width: 768px) {
  .change-password-card {
    max-width: 480px;
    min-height: auto;
    padding: 40px;
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  }
}
@media (min-width: 1200px) {
  .change-password-card {
    max-width: 520px;
    padding: 48px;
  }
}

.close-button {
  position: absolute;
  top: calc(var(--ion-safe-area-top, 0px) + 16px);
  right: 16px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}
.close-button:hover {
  background: var(--ion-color-primary-tint);
}
.close-button ion-icon {
  font-size: 22px;
}
@media (min-width: 768px) {
  .close-button {
    top: 16px;
  }
}

.card-header {
  text-align: center;
  margin-bottom: 28px;
  margin-top: calc(var(--ion-safe-area-top, 0px) + 24px);
}
@media (min-width: 768px) {
  .card-header {
    margin-top: 0;
  }
}

.logo-container {
  margin-bottom: 12px;
}

.card-logo {
  width: 72px;
  height: 72px;
  object-fit: contain;
}
@media (min-width: 768px) {
  .card-logo {
    width: 80px;
    height: 80px;
  }
}
@media (min-width: 1200px) {
  .card-logo {
    width: 100px;
    height: 100px;
  }
}

.card-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: var(--ion-color-primary);
}
@media (min-width: 768px) {
  .card-title {
    font-size: 1.75rem;
  }
}
@media (min-width: 1200px) {
  .card-title {
    font-size: 2rem;
  }
}

.card-subtitle {
  font-size: 0.9rem;
  color: var(--ion-color-medium-shade);
  margin: 0;
  line-height: 1.5;
}

.card-form {
  width: 100%;
}

.form-fields {
  margin-bottom: 24px;
}

.field-group {
  margin-bottom: 20px;
}

.cp-item {
  --background: transparent;
  --border-radius: 12px;
  --padding-start: 16px;
  --padding-end: 8px;
  --inner-padding-end: 0;
  --min-height: 56px;
  border: 2px solid var(--ion-color-medium-tint);
  border-radius: 12px;
  transition: all 0.3s ease;
}
.cp-item.item-has-focus {
  border-color: var(--ion-color-secondary);
  box-shadow: 0 0 0 3px rgba(51, 152, 219, 0.1);
}
.cp-item ion-button[slot=end] {
  --padding-start: 8px;
  --padding-end: 8px;
  --color: var(--ion-color-medium);
  margin: 0;
  align-self: center;
}

.field-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--ion-color-primary);
  margin-bottom: 4px;
}

.cp-input {
  --color: #0a1b38;
  --placeholder-color: var(--ion-color-medium);
  font-size: 1rem;
}

.error-text {
  display: block;
  color: var(--ion-color-danger);
  font-size: 0.8rem;
  margin: 4px 4px 0 4px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.submit-button {
  --border-radius: 16px;
  --box-shadow: 0 4px 12px rgba(51, 152, 219, 0.3);
  font-weight: 600;
  height: 48px;
}
.submit-button ion-icon {
  margin-right: 8px;
  font-size: 1.1rem;
}

@keyframes cpFadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/change-password/change-password.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,wGAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAGA,UAAA;AADF;AAIE;EAVF;IAWI,aAAA;EADF;AACF;;AAIA;EACE,kBAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,WAAA;EACA,kBAAA;EACA,mCAAA;EAGA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAHF;AAME;EAfF;IAgBI,gBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,0CAAA;EAHF;AACF;AAKE;EAvBF;IAwBI,gBAAA;IACA,aAAA;EAFF;AACF;;AAKA;EACE,kBAAA;EACA,+CAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;AAFF;AAIE;EACE,yCAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;AAME;EAxBF;IAyBI,SAAA;EAHF;AACF;;AAMA;EACE,kBAAA;EACA,mBAAA;EACA,sDAAA;AAHF;AAKE;EALF;IAMI,aAAA;EAFF;AACF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAFF;AAIE;EALF;IAMI,WAAA;IACA,YAAA;EADF;AACF;AAGE;EAVF;IAWI,YAAA;IACA,aAAA;EAAF;AACF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;AAAF;AAEE;EANF;IAOI,kBAAA;EACF;AACF;AACE;EAVF;IAWI,eAAA;EAEF;AACF;;AACA;EACE,iBAAA;EACA,oCAAA;EACA,SAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,8CAAA;EACA,mBAAA;EACA,yBAAA;AAEF;AAAE;EACE,wCAAA;EACA,6CAAA;AAEJ;AACE;EACE,oBAAA;EACA,kBAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;AACJ;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,4CAAA;EACA,eAAA;AAAF;;AAGA;EACE,cAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,qBAAA;EACA,gDAAA;EACA,gBAAA;EACA,YAAA;AAAF;AAEE;EACE,iBAAA;EACA,iBAAA;AAAJ;;AAIA;EACE;IAAO,UAAA;IAAY,2BAAA;EACnB;EAAA;IAAK,UAAA;IAAY,wBAAA;EAIjB;AACF","sourcesContent":[".change-password-content {\n  min-height: 100vh;\n  --background: linear-gradient(135deg, var(--ion-color-primary) 0%, var(--ion-color-primary-darker) 100%);\n}\n\n.cp-wrapper {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  // Mobile: card fills the screen; no extra padding around it.\n  padding: 0;\n\n  // Tablet/desktop: pad in from edges and center the card.\n  @media (min-width: 768px) {\n    padding: 24px;\n  }\n}\n\n.change-password-card {\n  position: relative;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  width: 100%;\n  padding: 32px 20px;\n  animation: cpFadeInUp 0.5s ease-out;\n\n  // Mobile: card takes full viewport, no rounding, no shadow.\n  min-height: 100vh;\n  border-radius: 0;\n  box-shadow: none;\n  max-width: none;\n\n  // Tablet/desktop: cap width, round corners, lift with shadow, auto height.\n  @media (min-width: 768px) {\n    max-width: 480px;\n    min-height: auto;\n    padding: 40px;\n    border-radius: 24px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  }\n\n  @media (min-width: 1200px) {\n    max-width: 520px;\n    padding: 48px;\n  }\n}\n\n.close-button {\n  position: absolute;\n  top: calc(var(--ion-safe-area-top, 0px) + 16px);\n  right: 16px;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: none;\n  background: var(--ion-color-primary);\n  color: var(--ion-color-primary-contrast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease;\n\n  &:hover {\n    background: var(--ion-color-primary-tint);\n  }\n\n  ion-icon {\n    font-size: 22px;\n  }\n\n  @media (min-width: 768px) {\n    top: 16px;\n  }\n}\n\n.card-header {\n  text-align: center;\n  margin-bottom: 28px;\n  margin-top: calc(var(--ion-safe-area-top, 0px) + 24px);\n\n  @media (min-width: 768px) {\n    margin-top: 0;\n  }\n}\n\n.logo-container {\n  margin-bottom: 12px;\n}\n\n.card-logo {\n  width: 72px;\n  height: 72px;\n  object-fit: contain;\n\n  @media (min-width: 768px) {\n    width: 80px;\n    height: 80px;\n  }\n\n  @media (min-width: 1200px) {\n    width: 100px;\n    height: 100px;\n  }\n}\n\n.card-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  color: var(--ion-color-primary);\n\n  @media (min-width: 768px) {\n    font-size: 1.75rem;\n  }\n\n  @media (min-width: 1200px) {\n    font-size: 2rem;\n  }\n}\n\n.card-subtitle {\n  font-size: 0.9rem;\n  color: var(--ion-color-medium-shade);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.card-form {\n  width: 100%;\n}\n\n.form-fields {\n  margin-bottom: 24px;\n}\n\n.field-group {\n  margin-bottom: 20px;\n}\n\n.cp-item {\n  --background: transparent;\n  --border-radius: 12px;\n  --padding-start: 16px;\n  --padding-end: 8px;\n  --inner-padding-end: 0;\n  --min-height: 56px;\n  border: 2px solid var(--ion-color-medium-tint);\n  border-radius: 12px;\n  transition: all 0.3s ease;\n\n  &.item-has-focus {\n    border-color: var(--ion-color-secondary);\n    box-shadow: 0 0 0 3px rgba(51, 152, 219, 0.1);\n  }\n\n  ion-button[slot='end'] {\n    --padding-start: 8px;\n    --padding-end: 8px;\n    --color: var(--ion-color-medium);\n    margin: 0;\n    align-self: center;\n  }\n}\n\n.field-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--ion-color-primary);\n  margin-bottom: 4px;\n}\n\n.cp-input {\n  --color: #0a1b38;\n  --placeholder-color: var(--ion-color-medium);\n  font-size: 1rem;\n}\n\n.error-text {\n  display: block;\n  color: var(--ion-color-danger);\n  font-size: 0.8rem;\n  margin: 4px 4px 0 4px;\n}\n\n.action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.submit-button {\n  --border-radius: 16px;\n  --box-shadow: 0 4px 12px rgba(51, 152, 219, 0.3);\n  font-weight: 600;\n  height: 48px;\n\n  ion-icon {\n    margin-right: 8px;\n    font-size: 1.1rem;\n  }\n}\n\n@keyframes cpFadeInUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
